import { INTEGRATION_TYPE } from '@config/index';

export type AgentChannel = {
  id?: string;
  agentId: string;
  integrationType: string;
  label?: string;
  defaultLanguage?: string;

  // deprecated
  facebookSetting?: any;
  rocketSetting?: any;
  twilioSetting?: any;
  larkSetting?: any;
  wechatPublicAccountSetting?: any;
  rbmSetting?: any;
  teleunionRCSSetting?: any;
  whatsAppBusinessSetting?: any;
  googleBusinessMessageSetting?: any;

  // new
  channelType: string;
  configuration: any;
};

export function agentChannelToLocal(res: any): AgentChannel {
  return {
    id: res.id,
    agentId: res.agent_id,
    integrationType: res.integration_type,
    label: res.label,
    defaultLanguage: res.default_language,
    facebookSetting: res.facebook_setting,
    rocketSetting: res.rocket_setting,
    twilioSetting: res.twilio_setting,
    larkSetting: res.lark_setting,
    wechatPublicAccountSetting: res.wechat_public_account_setting,
    rbmSetting: res.rbm_setting,
    teleunionRCSSetting: res.teleunion_rcs_setting,
    whatsAppBusinessSetting: res.whatsapp_business_setting,
    googleBusinessMessageSetting: res.google_business_message_setting,

    channelType: res.channel_type,
    configuration: res.configuration
  };
}

export function agentChannelToServer(data: AgentChannel) {
  return {
    id: data.id,
    agent_id: data.agentId,
    integration_type: data.integrationType,
    label: data.label,
    default_language: data.defaultLanguage,
    facebook_setting: data.facebookSetting,
    rocket_setting: data.rocketSetting,
    twilio_setting: data.twilioSetting,
    lark_setting: data.larkSetting,
    wechat_public_account_setting: data.wechatPublicAccountSetting,
    rbm_setting: data.rbmSetting,
    teleunion_rcs_setting: data.teleunionRCSSetting,
    whatsapp_business_setting: data.whatsAppBusinessSetting,
    google_business_message_setting: data.googleBusinessMessageSetting,

    channel_type: data.channelType,
    configuration: data.configuration
  };
}
